import { enqueueSnackbar } from 'notistack';

let useSnackbarRef;
let isOfflineNotified = false; // 👈 evita mostrar múltiples veces

export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = enqueueSnackbar;
  return null;
};

const SnackbarUtils = {
  success(msg) {
    useSnackbarRef(msg, { variant: 'success' });
  },
  info(msg, options = {}) {
    useSnackbarRef(msg, { variant: 'info', ...options });
  },
  warning(msg, options = {}) {
    useSnackbarRef(msg, { variant: 'warning', ...options });
  },
  error(msg, options = {}) {
    // Evita duplicados si está activado preventDuplicate
    if (options.preventDuplicate && isOfflineNotified) return;

    useSnackbarRef(msg, { variant: 'error', ...options });

    if (options.preventDuplicate) {
      isOfflineNotified = true;
      // Opcional: resetear el flag luego de un tiempo
      setTimeout(() => {
        isOfflineNotified = false;
      }, 5000);
    }
  },
  resetOfflineFlag() {
    isOfflineNotified = false;
  },
};

export default SnackbarUtils;
